// Catalog.ID Client — browser transport for the chat-root ceremony
// ============================================================================
// `crypto/chat-root-publication.ts` is deliberately DOM-free and imports no
// `api/*` module, so the same pipeline the browser ceremony runs is importable
// from Node by `apps/chat/dev/probes/m3-root-*` (the `dev/ceremony-sign.ts`
// rule: a probe must prove the CLIENT's code, not a second implementation).
// This file is the browser half of that split — the ~10-line binding from the
// transport interface to the real `api/*` wrappers.

import * as accountApi from './account';
import * as claimsApi from './claims';
import * as publicClaimsApi from './public-claims';
import type { ChatRootTransport } from '../crypto/chat-root-publication';

export function browserChatRootTransport(): ChatRootTransport {
    return {
        getKeyBag: () => accountApi.getKeyBag(),
        getOwnPublicKeys: async () =>
            (await accountApi.getOwnPublicKeys()).map(k => ({
                keyId: k.keyId, publicKey: k.publicKey,
            })),
        listPublicClaims: () => publicClaimsApi.listPublicClaims(),
        createClaim: (req) => claimsApi.createClaim(req),
        getValidatorKey: () => claimsApi.getValidatorKey(),
        validateClaim: (claimUuid, req) => claimsApi.validateClaim(claimUuid, req),
        verifyRegistryKey: (challenge, signature, publicKey) =>
            claimsApi.verifyRegistryKey(challenge, signature, publicKey),
        cancelValidation: (claimUuid) => claimsApi.cancelValidation(claimUuid),
        listOperators: () => publicClaimsApi.listOperators(),
        publishClaim: (claimUuid, req) => publicClaimsApi.publishClaim(claimUuid, req),
    };
}
